import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TestimonialCard = ({ testimonial }) => {
  const { 
    clientName, 
    clientRole, 
    clientImage, 
    clientImageAlt,
    companyName, 
    serviceType, 
    rating, 
    testimonialText, 
    projectDetails,
    date,
    isCommercial 
  } = testimonial;

  return (
    <div className="bg-card rounded-lg border border-border p-6 md:p-8 hover:shadow-elevated transition-shadow duration-300">
      <div className="flex items-start gap-4 mb-4">
        <Image
          src={clientImage}
          alt={clientImageAlt}
          className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <h3 className="font-headline font-semibold text-foreground text-lg md:text-xl mb-1">
            {clientName}
          </h3>
          <p className="text-muted-foreground text-sm md:text-base font-body">
            {clientRole}
            {companyName && (
              <span className="block md:inline md:ml-1">
                {isCommercial && <Icon name="Building2" size={14} className="inline mr-1" />}
                {companyName}
              </span>
            )}
          </p>
        </div>
        <div className="flex items-center gap-1 flex-shrink-0">
          {[...Array(5)]?.map((_, index) => (
            <Icon
              key={index}
              name="Star"
              size={16}
              className={index < rating ? 'text-accent fill-accent' : 'text-muted'}
            />
          ))}
        </div>
      </div>
      <div className="mb-4">
        <div className="flex flex-wrap gap-2 mb-3">
          <span className={`px-3 py-1 rounded-full text-xs md:text-sm font-medium ${
            isCommercial 
              ? 'bg-primary/10 text-primary' :'bg-secondary/10 text-secondary'
          }`}>
            {isCommercial ? 'Commercial' : 'Residential'}
          </span>
          <span className="px-3 py-1 rounded-full text-xs md:text-sm font-medium bg-muted text-muted-foreground">
            {serviceType}
          </span>
        </div>
        <p className="text-foreground font-body text-sm md:text-base leading-relaxed mb-3">
          "{testimonialText}"
        </p>
        {projectDetails && (
          <p className="text-muted-foreground text-xs md:text-sm font-body italic">
            Project: {projectDetails}
          </p>
        )}
      </div>
      <div className="flex items-center justify-between text-xs md:text-sm text-muted-foreground pt-4 border-t border-border">
        <span className="font-body">{date}</span>
        <div className="flex items-center gap-1 text-success">
          <Icon name="CheckCircle2" size={16} />
          <span className="font-medium">Verified Client</span>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;